import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: 'user',
    initialState: {
      value: false,
    },
    reducers: {
      logIn: (state) => {
        state.value = true
      },
      logOut: (state) => {
        state.value = false
      }
    },
})
export const { logIn, logOut } = userSlice.actions
export default userSlice.reducer